module.exports = __webpack_public_path__ + "img/imagem9.5a4f2286.svg";